import { createSwiper } from '../adapters/SwiperAdapter';

export const tourReviewsOnLoadHandler = () => {
    createSwiper('.slider-tourReview', {
        slidesPerView: 2.5,
        spaceBetween: 10,
        speed: 300,
        loop: false,
        navigation: {
            nextEl: '.tourReviews .swiper-nav--arrow-next',
            prevEl: '.tourReviews .swiper-nav--arrow-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2.5,
            },
        },
    });
};